// extracted by mini-css-extract-plugin
export default {"layer":"VendorStoreModal_layer__Vcb-Q","popup":"VendorStoreModal_popup__dpclK","cancel":"VendorStoreModal_cancel__9vx-1"};